import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { employeeFormLabel } from "../Constant";

function ViewBasicDetailsComponent({ form }) {
  return (
    <div>
      <h5>Basic Details</h5>
      <Row>
        <Col md={4}>
          <h5>{employeeFormLabel["firstName"]}</h5>
          <p>{form?.firstName}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["middleName"]}</h5>
          <p>{form?.middleName}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["lastName"]}</h5>
          <p>{form?.lastName}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["employeeId"]}</h5>
          <p>{form?.employeeId}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["email"]}</h5>
          <p>{form?.email}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["mobileNumber"]}</h5>
          <p>{form?.mobileNumber}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["aadharNumber"]}</h5>
          <p>{form?.aadharNumber}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["dob"]}</h5>
          <p>{form?.dob ? DDMMYYYYFormat(form?.dob) : ""}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["gender"]}</h5>
          <p>{form?.gender}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["designation"]}</h5>
          <p>{form?.designation}</p>
        </Col>
        <Col md={4}>
          <h5>{employeeFormLabel["dateOfJoining"]}</h5>
          <p>{form?.dateOfJoining ? DDMMYYYYFormat(form?.dateOfJoining) : ""}</p>
        </Col>
      </Row>
    </div>
  );
}

export default ViewBasicDetailsComponent;
